<div class="db-create-ai-assistant-finalize__steps">
  <ul class="db-create-ai-assistant-finalize__steps-items">
    <li *ngFor="let step of steps, let i = index"
        [ngClass]="{'process': step?.status === 'process','passed': step?.status === 'passed',
        'show-stroke': step.status === 'passed' && steps[i + 1]?.status === 'passed'}">
      <img *ngIf="step?.status === 'todo'; else loader"
         src="assets/images/icons/stroke-loading.svg" />
      <ng-template #loader>
         <span class="step" [ngClass]="{
      'ds-spinner-circle spinner': step?.status === 'process',
      'db-icon db-icon-ds-checkmark': step?.status === 'passed'
      }"></span>
      </ng-template>
      <p>
      <span class="db-create-ai-assistant-finalize__step-label ml12" [innerHTML]="step?.label"></span>
      <span class="db-create-ai-assistant-finalize__step-desc ml12" *ngIf="step?.status === 'process'" [innerHTML]="step?.description"></span>
      </p>
    </li>
  </ul>

  <div class="db-create-ai-assistant-finalize__progress">
    {{ progress }}%
  </div>
</div>
